export const FONT_RECOMMNEDED_SIZES = [
    'Extra Small',
    'Small',
    'Medium',
    'Large',
    'Extra Large',
] as const;


export enum FontRecommededSize {
    'Extra Small' = 200,
    'Small' = 300,
    'Medium' = 400,
    'Large' = 700,
    'Extra Large' = 800,
}

